module.exports = __webpack_public_path__ + "img/icon-star1-active.9d901bdf.png";